import cloneDeep from 'lodash/cloneDeep'
import Vue from 'vue'
import enLocale from 'element-ui/lib/locale/lang/en'
import cnLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
const initState ={
    currentLanguage:'CN'
}

export default {
    state: cloneDeep(initState),
    mutations: {
        languageResetStore(state){
            if(window.vm.$store.state){
                Vue.set(window.vm.$store.state,'language',cloneDeep(initState))
            }
        },
        setLanguage(state, valObj) {
            for (let key in valObj) {
                //没有在state初始化的属性需要用set强更新
                Vue.set(state,key,valObj[key])
                if(key === 'currentLanguage'){
                    if(valObj[key] === 'EN'){
                        locale.use(enLocale)
                    }else{
                        locale.use(cnLocale)
                    }
                }
            }
        }
    },
    actions: {},
    getters: {}
}
